import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const PunchCardItem = ({ num, isPunched, baseClass }) => {
    return (
        <div
            data-is-punched={isPunched}
            className={clsx(`${baseClass}-punch`, {
                'm2g-is-punched': isPunched,
            })}
        >
            <div className={`${baseClass}-punch-content`}>
                <div
                    className={clsx(
                        `${baseClass}-punch-content`,
                        `${baseClass}-punch-content--number`
                    )}
                >
                    {num}
                </div>
                <span
                    className={clsx(
                        `${baseClass}-punch-content`,
                        `${baseClass}-punch-content--tick`,
                        'm2g-icon',
                        'm2g-icon--tick'
                    )}
                />
            </div>
        </div>
    );
};

PunchCardItem.propTypes = {
    num: PropTypes.number.isRequired,
    isPunched: PropTypes.bool.isRequired,
    baseClass: PropTypes.string.isRequired,
};

export default PunchCardItem;
